import { Collapse, Expand } from '../Transition.types';

export const expandDefault: Expand = {
  duration: 'medium01',
  direction: 'bottomToTop',
};
export const collapseDefault: Collapse = {
  ...(expandDefault as Collapse),
};

export const expectedOneWayValuesByDirection = {
  topToBottom: {
    entering: {
      bottom: '100%',
    },
    entered: {
      bottom: '0%',
    },
    exiting: {
      bottom: '-100%',
    },
    exited: {
      bottom: '100%',
    },
  },
  bottomToTop: {
    entering: {
      bottom: '-100%',
    },
    entered: {
      bottom: '0%',
    },
    exiting: {
      bottom: '100%',
    },
    exited: {
      bottom: '-100%',
    },
  },
  leftToRight: {
    entering: {
      left: '-100%',
    },
    entered: {
      left: '0%',
    },
    exiting: {
      left: '100%',
    },
    exited: {
      left: '-100%',
    },
  },
  rightToLeft: {
    entering: {
      left: '100%',
    },
    entered: {
      left: '0%',
    },
    exiting: {
      left: '-100%',
    },
    exited: {
      left: '100%',
    },
  },
};

export const expectedVerticalValuesWithReversedDirections = {
  bottomToTopTopToBottom: {
    entering: {
      bottom: '-100%',
    },
    entered: {
      bottom: '0%',
    },
    exiting: {
      bottom: '-100%',
    },
    exited: {
      bottom: '-100%',
    },
  },
  topToBottomBottomToTop: {
    entering: {
      bottom: '100%',
    },
    entered: {
      bottom: '0%',
    },
    exiting: {
      bottom: '100%',
    },
    exited: {
      bottom: '100%',
    },
  },
};

export const differentVerticalDirections: {
  expand: Expand;
  collapse: Collapse;
  type: string;
}[] = [
  {
    expand: {
      ...expandDefault,
      direction: 'bottomToTop',
    },
    collapse: {
      ...collapseDefault,
      direction: 'topToBottom',
    },
    type: 'bottomToTopTopToBottom',
  },
  {
    expand: {
      ...expandDefault,
      direction: 'topToBottom',
    },
    collapse: {
      ...collapseDefault,
      direction: 'bottomToTop',
    },
    type: 'topToBottomBottomToTop',
  },
];

export const expectedHorizontalValuesWithReversedDirections = {
  leftToRightRightToLeft: {
    entering: {
      left: '-100%',
    },
    entered: {
      left: '0%',
    },
    exiting: {
      left: '-100%',
    },
    exited: {
      left: '-100%',
    },
  },
  rightToLeftLeftToRight: {
    entering: {
      left: '100%',
    },
    entered: {
      left: '0%',
    },
    exiting: {
      left: '100%',
    },
    exited: {
      left: '100%',
    },
  },
};

export const differentHorizontalDirections: {
  expand: Expand;
  collapse: Collapse;
  type: string;
}[] = [
  {
    expand: {
      ...expandDefault,
      direction: 'leftToRight',
    },
    collapse: {
      ...collapseDefault,
      direction: 'rightToLeft',
    },
    type: 'leftToRightRightToLeft',
  },
  {
    expand: {
      ...expandDefault,
      direction: 'rightToLeft',
    },
    collapse: {
      ...collapseDefault,
      direction: 'leftToRight',
    },
    type: 'rightToLeftLeftToRight',
  },
];

const bottomToTopLeftToRight = {
  entering: {
    bottom: '-100%',
    height: '100px',
    width: '100%',
  },
  entered: {
    bottom: '0%',
    left: '0%',
    height: '100%',
    width: '100px',
  },
  exiting: {
    left: '100%',
    height: '100%',
    width: '100px',
  },
  exited: {
    bottom: '-100%',
    left: '0%',
    height: '100%',
    width: '100px',
  },
};
const leftToRightBottomToTop = {
  entering: {
    left: '-100%',
    height: '100%',
    width: '100px',
  },
  entered: {
    bottom: '0%',
    left: '0%',
    height: '100px',
    width: '100%',
  },
  exiting: {
    bottom: '100%',
    height: '100px',
    width: '100%',
  },
  exited: {
    bottom: '0%',
    left: '-100%',
    height: '100px',
    width: '100%',
  },
};

export const expectedValuesWithDifferentDirections = {
  bottomToTopLeftToRight,
  bottomToTopRightToLeft: {
    ...bottomToTopLeftToRight,
    exiting: {
      left: '-100%',
      height: '100%',
      width: '100px',
    },
  },
  topToBottomLeftToRight: {
    ...bottomToTopLeftToRight,
    entering: {
      bottom: '100%',
      height: '100px',
      width: '100%',
    },
    exited: {
      bottom: '100%',
      left: '0%',
      height: '100%',
      width: '100px',
    },
  },
  topToBottomRightToLeft: {
    ...bottomToTopLeftToRight,
    entering: {
      bottom: '100%',
      height: '100px',
      width: '100%',
    },
    exiting: {
      left: '-100%',
      height: '100%',
      width: '100px',
    },
    exited: {
      bottom: '100%',
      left: '0%',
      height: '100%',
      width: '100px',
    },
  },
  leftToRightBottomToTop,
  leftToRightTopToBottom: {
    ...leftToRightBottomToTop,
    exiting: {
      bottom: '-100%',
      height: '100px',
      width: '100%',
    },
  },
  rightToLeftbottomToTop: {
    ...leftToRightBottomToTop,
    entering: {
      left: '100%',
      height: '100%',
      width: '100px',
    },
    exited: {
      bottom: '0%',
      left: '100%',
      height: '100px',
      width: '100%',
    },
  },
  rightToLefttopToBottom: {
    ...leftToRightBottomToTop,
    entering: {
      left: '100%',
      height: '100%',
      width: '100px',
    },
    exiting: {
      bottom: '-100%',
      height: '100px',
      width: '100%',
    },
    exited: {
      bottom: '0%',
      left: '100%',
      height: '100px',
      width: '100%',
    },
  },
};

export const differentDirections: {
  expand: Expand;
  collapse: Collapse;
  type: string;
}[] = [
  {
    expand: {
      ...expandDefault,
      direction: 'bottomToTop',
    },
    collapse: {
      ...collapseDefault,
      direction: 'leftToRight',
    },
    type: 'bottomToTopLeftToRight',
  },
  {
    expand: {
      ...expandDefault,
      direction: 'bottomToTop',
    },
    collapse: {
      ...collapseDefault,
      direction: 'rightToLeft',
    },
    type: 'bottomToTopRightToLeft',
  },
  {
    expand: {
      ...expandDefault,
      direction: 'topToBottom',
    },
    collapse: {
      ...collapseDefault,
      direction: 'leftToRight',
    },
    type: 'topToBottomLeftToRight',
  },
  {
    expand: {
      ...expandDefault,
      direction: 'topToBottom',
    },
    collapse: {
      ...collapseDefault,
      direction: 'rightToLeft',
    },
    type: 'topToBottomRightToLeft',
  },
  {
    expand: {
      ...expandDefault,
      direction: 'leftToRight',
    },
    collapse: {
      ...collapseDefault,
      direction: 'bottomToTop',
    },
    type: 'leftToRightBottomToTop',
  },
  {
    expand: {
      ...expandDefault,
      direction: 'leftToRight',
    },
    collapse: {
      ...collapseDefault,
      direction: 'topToBottom',
    },
    type: 'leftToRightTopToBottom',
  },
  {
    expand: {
      ...expandDefault,
      direction: 'rightToLeft',
    },
    collapse: {
      ...collapseDefault,
      direction: 'bottomToTop',
    },
    type: 'rightToLeftbottomToTop',
  },
  {
    expand: {
      ...expandDefault,
      direction: 'rightToLeft',
    },
    collapse: {
      ...collapseDefault,
      direction: 'topToBottom',
    },
    type: 'rightToLefttopToBottom',
  },
];
